module.exports = {
	"status": "OK",
	"books": [
		{
			"title": "the-burning-girl",
			"isbn": "9780393356052",
			"bookTitle": "The Burning Girl",
			"subtitle": "A Novel",
			"url": "the-burning-girl",
			"coverImage": "http://cdn.wwnorton.com/marketing/trade/messud/9780393356052_252x380.jpg",
			"summary": "<p><strong>NOW IN PAPERBACK. A <em>New York Times</em> bestseller and finalist for the <em>Los Angeles Times</em> Book Prize.</strong></p>\n\n<p><strong>Named one of the best books of the year by the <em>Los Angeles Times</em>, <em>San Francisco Chronicle</em>, <em>Vogue</em>, <em>NPR</em>, <em>Financial Times</em>, <em>Town & Country</em>, <em>Kirkus Reviews</em>, <em>Publishers Weekly</em>, <em>Refinery29</em>, and <em>Lithub</em>.</strong></p>\n\n<p>Julia and Cassie have been friends since nursery school. They have shared everything, including their desire to escape the stifling limitations of their birthplace, the quiet town of Royston, Massachusetts. But as the two girls enter adolescence, their paths diverge and Cassie sets out on a journey that will put her life in danger and shatter her oldest friendship. <em>The Burning Girl</em> is a complex examination of the stories we tell ourselves about youth and friendship, and straddles, expertly, childhood’s imaginary worlds and painful adult reality―crafting a true, immediate portrait of female adolescence.</p>\n\n<p>Claire Messud, one of our finest novelists, is as accomplished at weaving a compelling fictional world as she is at asking the big questions: To what extent can we know ourselves and others? What are the stories we create to comprehend our lives and relationships? Brilliantly mixing fable and coming-of-age tale, <em>The Burning Girl</em> gets to the heart of these matters in an absolutely irresistible way.</p>\n\n<p><strong><a href=\"http://cdn.wwnorton.com/marketing/trade/messud/The-Burning-Girl-Reading-Group-Guide.pdf\">Reading Group Guide for <em>The Burning Girl</em> (PDF)</a></strong></p>\n",
			"orderButtonText": "Buy Now",
			"retailersLinks": [
				{
					"link": "https://www.amazon.com/dp/0393356051/",
					"retailer": "Amazon"
				},
				{
					"link": "https://www.barnesandnoble.com/w/the-burning-girl-claire-messud/1125747921?ean=9780393356052",
					"retailer": "Barnes & Noble"
				},
				{
					"link": "http://www.booksamillion.com/p/9780393356052",
					"retailer": "Books-A-Million"
				},
				{
					"link": "https://itunes.apple.com/us/book/the-burning-girl-a-novel/id1213487535?mt=11",
					"retailer": "iBooks"
				},
				{
					"link": "https://www.indiebound.org/book/9780393356052",
					"retailer": "IndieBound"
				}
			],
			"reviews": {
				"showReviews": true,
				"sectionTitle": "Endorsements & Reviews",
				"reviews": [
					{
						"publication": "People",
						"text": "<p>\"In pared-down, aching prose, Messud reminds us that no one sheds girlhood's tender skin without getting hurt.\"</p>\n"
					},
					{
						"publication": "The New Yorker ",
						"text": "<p>\"The friendship of two girls, Julia and Cassie, animates this slim, dreamlike novel…Messud plays, lightly, with familiar archetypes, deftly abstracting her tale so that it flares into myth.\"</p>\n"
					},
					{
						"publication": "New York Times Magazine",
						"text": "<p>\"[Messud] has specialized in creating unusual female characters with ferocious, imaginative inner lives…and quietly making a case for women's interiority as a subject worthy of the most serious examination.\"</p>\n",
						"reviewBy": "Ruth Franklin"
					},
					{
						"publication": "Chicago Tribune",
						"text": "<p><strong>“</strong>[A] masterwork of psychological fiction…Messud teases readers with a psychological mystery, withholding information and then cannily parceling it out.\"<br />\n<br />\n </p>\n"
					},
					{
						"publication": "San Francisco Chronicle",
						"text": "<p>\"Breathtaking…With this novel, Messud brings her own particular brand of astuteness and emotional intelligence through her careful and thoughtful prose.\"</p>\n"
					},
					{
						"publication": "Parnasssus",
						"text": "<p>“Claire Messud has hypnotized me. <em>The Burning Girl</em> is an engrossing, fierce, coming-of-age fable built impeccably on language that stuns. It is as though Messud is whispering the story directly into the reader's ear and you won't dare to pull away, not even for a moment.”</p>\n",
						"reviewBy": "Halley Parry"
					},
					{
						"publication": "Third Place Books",
						"text": "<p><strong>“</strong>Claire Messud further establishes herself as one of our most essential writers with each book and in <em>The Burning Girl</em>, she has sharpened her ability, translating her emotional acuity into the most powerful of literary languages: accessibility.”<br />\n<br />\n </p>\n",
						"reviewBy": "Wesley Minter"
					},
					{
						"publication": "Seminary Coop Bookstore",
						"text": "<p>“With her masterfully measured prose, Messud has given us a nuanced, pitch-perfect tale of adolescence. <em>The Burning Girl</em> is a novel that will endure, the rare novel that touches the heart, the mind, and the spine.”</p>\n",
						"reviewBy": "Jeff Deutsch"
					},
					{
						"publication": "Boswell Book Company, Milwaukee, Wisconsin",
						"text": "<p><strong>“</strong>Messud perfectly captures that time when we first discover people outside of our families who take up residence in our hearts.”</p>\n",
						"reviewBy": "Sharon K. Nagel"
					},
					{
						"publication": "University Bookstore",
						"text": "<p><strong>“</strong>This tightly written coming of age novel about female friendship is sure to appeal to fans of Elena Ferrante's <em>Neapolitan Quartet</em>. Claire Messud's captivating novel <em>The Burning Girl</em> will leave you breathless.”</p>\n",
						"reviewBy": "Caitlin L. Baker"
					},
					{
						"publication": "Square Books",
						"text": "<p>“I have long admired Claire Messud's work and <em>The Burning Girl</em> is a powerful reminder of why she is often hailed as one of our finest novelists. Told in an utterly compelling voice, this is a book that will rattle around in the reader's mind long after they have turned the last page.”<br />\n<br />\n </p>\n",
						"reviewBy": "Cody Morrison"
					},
					{
						"publication": "King's English",
						"text": "<p><strong>“</strong>A beautiful exploration of the power of truth, myth and the attempt for redemption.”</p>\n",
						"reviewBy": "Jan Sloan"
					},
					{
						"publication": "Literati Bookstore",
						"text": "<p>“At times the novel felt as though taken from the pages of my own girlhood friendships - so spot on in its observations that it felt eerily familiar. An elegant, smart, and sharply wise novel that is beautiful in it troubling observations on what it means to navigate being a girl in this world.”</p>\n",
						"reviewBy": "Hilary Gustafson"
					},
					{
						"publication": "Watermark Books",
						"text": "<p>“<em>The Burning Girl</em> is an essential addition to the canon of ‘coming of age’ novels.”</p>\n",
						"reviewBy": "Sarag Bagby"
					},
					{
						"publication": "Elliott Bay Book Company",
						"text": "<p>“Claire Messud is—again—a master at making these small pieces of life recognizable for the larger whole stories that can be told. Tell it, she does.”</p>\n",
						"reviewBy": "Rick Simonson"
					}
				]
			},
			"_doc": "96075927621a502ce4cb",
			"attachments": {},
			"_system": {
				"deleted": false,
				"changeset": "397:8b6b858d6459ce46ef31",
				"created_on": {
					"timestamp": "12-May-2017 19:32:50",
					"year": 2017,
					"month": 4,
					"day_of_month": 12,
					"hour": 19,
					"minute": 32,
					"second": 50,
					"millisecond": 441,
					"ms": 1494617570441,
					"iso_8601": "2017-05-12T19:32:50Z"
				},
				"created_by": "mmcginnis",
				"created_by_principal_id": "7683d13972fe921163df",
				"created_by_principal_domain_id": "3d96ab762d6c9248425b",
				"modified_on": {
					"timestamp": "04-Jun-2018 17:33:38",
					"year": 2018,
					"month": 5,
					"day_of_month": 4,
					"hour": 17,
					"minute": 33,
					"second": 38,
					"millisecond": 473,
					"ms": 1528133618473,
					"iso_8601": "2018-06-04T17:33:38Z"
				},
				"modified_by": "scolca",
				"modified_by_principal_id": "a32a0841493c0930c2fa",
				"modified_by_principal_domain_id": "3d96ab762d6c9248425b",
				"previousChangeset": "395:345691743e7db39ed44a",
				"edited_on": {
					"timestamp": "04-Jun-2018 17:33:38",
					"year": 2018,
					"month": 5,
					"day_of_month": 4,
					"hour": 17,
					"minute": 33,
					"second": 38,
					"millisecond": 473,
					"ms": 1528133618473,
					"iso_8601": "2018-06-04T17:33:38Z"
				},
				"edited_by": "scolca",
				"edited_by_principal_id": "a32a0841493c0930c2fa",
				"edited_by_principal_domain_id": "3d96ab762d6c9248425b"
			},
			"_statistics": {
				"a:child": 1,
				"a:child_INCOMING": 1,
				"a:has_role": 4,
				"a:has_role_INCOMING": 4,
				"a:linked": 2,
				"a:linked_INCOMING": 2
			},
			"insightNode": "99f505c98cb37175bbe5/7df865401a95482cf6ba/96075927621a502ce4cb"
		},
		{
			"title": "the-emperor-s-children",
			"isbn": " 9780307276667",
			"bookTitle": "The Emperor's Children ",
			"url": "the-emperor's-children-",
			"coverImage": "http://dz0xuupaj9dvo.cloudfront.net/cover/Claire_Messud/TheEmperorsChildren.jpg",
			"summary": "<p><strong>NATIONAL BESTSELLER</strong></p>\n\n<p><br />\n<strong>A <em>New York Times Book Review </em>Best Book of the Year</strong></p>\n\n<p><br />\n<em>The Emperor&rsquo;s Children</em> is a richly drawn, brilliantly observed novel of fate and fortune&mdash;about the intersections in the lives of three friends, now on the cusp of their thirties, making their way--and not-- in New York City. In this<em> </em>tour de force, the celebrated author Claire Messud brings to life a city, a generation, and the way we live in this moment.</p>\n",
			"orderButtonText": "Buy Now",
			"retailersLinks": [
				{
					"link": "https://www.amazon.com/Emperors-Children-Claire-Messud/dp/030727666X/ref=tmm_pap_swatch_0?_encoding=UTF8&qid=1494618834&sr=8-1",
					"retailer": "Amazon"
				},
				{
					"link": "http://www.barnesandnoble.com/w/emperors-children-claire-messud/1100267676?ean=9780307276667",
					"retailer": "Barnes & Noble"
				},
				{
					"link": "http://www.booksamillion.com/p/Emperors-Children/Claire-Messud/9780307276667?id=6946195072950",
					"retailer": "Books-A-Million"
				},
				{
					"link": "https://itunes.apple.com/us/book/the-emperors-children/id420264573?mt=11",
					"retailer": "iBooks"
				},
				{
					"link": "http://www.indiebound.org/book/9780307276667",
					"retailer": "IndieBound"
				}
			],
			"reviews": {
				"showReviews": true,
				"sectionTitle": "Praise for The Emperor's Children",
				"reviews": [
					{
						"publication": "The New York Times ",
						"text": "<p>A masterly comedy of manners&hellip;Splendid.</p>\n"
					},
					{
						"publication": "The Economist",
						"text": "<p>&ldquo;A great achievement. . . . Intelligent and unsparing . . . <em>The Emperor&#39;s Children</em> is likely to be one of the most talked-about novels. . . . Buy two copies; give one to a friend.&rdquo;</p>\n"
					},
					{
						"publication": "USA Today",
						"text": "<p>&ldquo;Engaging. . . . The characters take on intriguing nuances as Messud satirizes and challenges perceived notions of culture, class and social mobility. Her vivid, juicy writing ensures an exhilarating read throughout.&rdquo;</p>\n"
					},
					{
						"publication": "Elle",
						"text": "<p>&ldquo;Ambitious, glamorous, and gutsy. . . . A marvel of bold momentum and kinetic imagination.&rdquo;</p>\n"
					},
					{
						"publication": "Los Angeles Times",
						"text": "<p>&quot;A robust, canny and surprisingly searching novel [told] with a light-handed irony that is, by turns, as measured as Edith Wharton&#39;s and as cutting as Tom Wolfe&#39;s. . . . Dazzling.&rdquo;</p>\n"
					}
				]
			},
			"_doc": "03bb7dd665c07a46a1ce",
			"attachments": {},
			"_system": {
				"deleted": false,
				"changeset": "295:c8c7096aa10f9e8b7177",
				"created_on": {
					"timestamp": "12-May-2017 19:56:51",
					"year": 2017,
					"month": 4,
					"day_of_month": 12,
					"hour": 19,
					"minute": 56,
					"second": 51,
					"millisecond": 719,
					"ms": 1494619011719,
					"iso_8601": "2017-05-12T19:56:51Z"
				},
				"created_by": "mmcginnis",
				"created_by_principal_id": "7683d13972fe921163df",
				"created_by_principal_domain_id": "3d96ab762d6c9248425b",
				"modified_on": {
					"timestamp": "26-May-2017 17:43:46",
					"year": 2017,
					"month": 4,
					"day_of_month": 26,
					"hour": 17,
					"minute": 43,
					"second": 46,
					"millisecond": 253,
					"ms": 1495820626253,
					"iso_8601": "2017-05-26T17:43:46Z"
				},
				"modified_by": "sdike",
				"modified_by_principal_id": "e4180bb7661ac1511f07",
				"modified_by_principal_domain_id": "3d96ab762d6c9248425b",
				"previousChangeset": "265:c9cac47508d585c05286"
			},
			"_statistics": {
				"a:child": 1,
				"a:child_INCOMING": 1,
				"a:has_role": 4,
				"a:has_role_INCOMING": 4,
				"a:linked": 1,
				"a:linked_INCOMING": 1
			},
			"insightNode": "99f505c98cb37175bbe5/7df865401a95482cf6ba/03bb7dd665c07a46a1ce"
		},
		{
			"title": "the-woman-upstairs",
			"isbn": "9780307743763",
			"bookTitle": "The Woman Upstairs ",
			"subtitle": "A Novel",
			"url": "the-woman-upstairs-",
			"coverImage": "http://dz0xuupaj9dvo.cloudfront.net/cover/Claire_Messud/TheWomanUpstairs.jpg",
			"summary": "<p><strong>A <em>New York Times</em>&nbsp;<em>Book Review</em> Notable Book &bull;&nbsp;A <em>Washington Post </em>Top Ten Book of the Year &bull;&nbsp;A<em> Chicago Tribune</em> Noteworthy Book &bull;&nbsp;A <em>Huffington Post</em> Best Book &bull; A <em>Boston Globe</em> Best Book of the Year &bull;&nbsp;A <em>Kirkus</em> Best Fiction Book &bull; A Goodreads Best Book</strong><br />\n<br />\nNora Eldridge is a reliable, but unremarkable, friend and neighbor, always on the fringe of other people&rsquo;s achievements. But the arrival of the Shahid family&mdash;dashing Skandar, a Lebanese scholar, glamorous Sirena, an Italian artist, and their son, Reza&mdash;draws her into a complex and exciting new world. Nora&rsquo;s happiness pushes her beyond her boundaries, until Sirena&rsquo;s careless ambition leads to a shattering betrayal. Told with urgency, intimacy, and piercing emotion, this <em>New York Times </em>bestselling novel is the riveting confession of a woman awakened, transformed, and abandoned by a desire for a world beyond her own.</p>\n",
			"orderButtonText": "Buy Now",
			"retailersLinks": [
				{
					"link": "https://www.amazon.com/Woman-Upstairs-Vintage-Contemporaries/dp/0307743764/ref=tmm_pap_swatch_0?_encoding=UTF8&qid=1494859323&sr=8-2",
					"retailer": "Amazon"
				},
				{
					"link": "http://www.barnesandnoble.com/w/woman-upstairs-claire-messud/1110695059?ean=9780307743763",
					"retailer": "Barnes & Noble"
				},
				{
					"link": "http://www.booksamillion.com/p/Woman-Upstairs/Claire-Messud/9780307743763?id=6946195072950",
					"retailer": "Books-A-Million"
				},
				{
					"link": "https://itunes.apple.com/us/book/the-woman-upstairs/id576218701?mt=11",
					"retailer": "iBooks"
				},
				{
					"link": "http://www.indiebound.org/book/9780307743763",
					"retailer": "IndieBound"
				}
			],
			"reviews": {
				"showReviews": true,
				"sectionTitle": "Praise for The Woman Upstairs",
				"reviews": [
					{
						"publication": "NPR",
						"text": "<p>&ldquo;Fantastic. . . . Burst[ing] with rage and desire. . . . Messud writes about happiness, and about infatuation&mdash;about love&mdash;more convincingly than any author I&rsquo;ve encountered in years.&rdquo;</p>\n",
						"reviewBy": "Lionel Shriver"
					},
					{
						"publication": "The New York Times Book Review",
						"text": "<p>&ldquo;A liberation. Messud&rsquo;s prose grabs the reader by the collar. . . . In this ingenious, disquieting novel, she has assembled an intricate puzzle of self-belief and self-doubt, showing the peril of seeking your own image in someone else&rsquo;s distorted mirror&mdash;or even, sometimes, in your own.&rdquo;</p>\n"
					},
					{
						"publication": "The Wall Street Journal",
						"text": "<p>&ldquo;A trenchant exploration into the mercenary nature of artistic creation. . . . Destined to become a cultural benchmark.&rdquo;</p>\n"
					},
					{
						"publication": "The Washington Post",
						"text": "<p>&ldquo;Fantastically smart.&rdquo;</p>\n"
					},
					{
						"publication": "The New Yorker",
						"text": "<p>&ldquo;Riveting. . . . Messud is adept at evoking complex psychological territory. . . . She is interested in the identities that women construct for themselves, and in the maddening chasm that often divides intensity of aspiration from reality of achievement.&rdquo;</p>\n"
					},
					{
						"publication": "The Miami Herald",
						"text": "<p>&ldquo;<em>The Woman Upstairs</em>&nbsp;dazzles. . . . [Messud is] among our greatest contemporary writers.&rdquo;</p>\n"
					},
					{
						"publication": "Chicago Tribune (Editor’s Choice)",
						"text": "<p>&ldquo;A work of such great emotional velocity.&rdquo;</p>\n"
					},
					{
						"publication": "Entertainment Weekly",
						"text": "<p>&ldquo;Exhilarating. . . . After the final powerful paragraphs, in which Nora howls in galvanized fury, throw it down and have a drink, or a dreamless nap. Don&rsquo;t be surprised if you then pick it back up and start all over again. A&rdquo;</p>\n"
					},
					{
						"publication": "Los Angeles Times ",
						"text": "<p>&nbsp;&ldquo;Startling: a psychological and intellectual thriller.&rdquo;</p>\n"
					},
					{
						"publication": "The Huffington Post",
						"text": "<p>&ldquo;Mesmerizing. . . . While it was Messud&rsquo;s achingly beautiful characters crystallizing midlife that drew me in, it was her grotesque portrait of an inner life free to swell, untethered to the realities of children, a spouse and a mortgage that made me think.&rdquo;</p>\n"
					},
					{
						"publication": "Vogue",
						"text": "<p>&ldquo;Corrosively funny. . . . At a time at which there seems to be plenty for creative women to be angry about, Nora&rsquo;s rant feels refreshing.&rdquo;</p>\n"
					},
					{
						"publication": "People (A People’s Pick)",
						"text": "<p>&ldquo;Engrossing. . . . Think of [Nora] as the woman who leans out: the A student who puts others&rsquo; needs first. . . . Through the ensuing drama, which includes one of the more shocking betrayals in recent fiction, Messud raises questions about women&rsquo;s still-circumscribed roles and the price of success.&rdquo;</p>\n"
					},
					{
						"publication": "The Boston Globe",
						"text": "<p>&ldquo;A supremely well-crafted page-turner with a shocker of an ending.&rdquo;</p>\n"
					},
					{
						"publication": "The Denver Post",
						"text": "<p>&ldquo;[Messud has] a literary critic&rsquo;s knack for marshaling and reverberating themes and, most crucially, a broad and deep empathy. . . . <em>The Woman Upstairs</em>&nbsp;is first-rate: It asks unsettling, unanswerable questions.&rdquo;</p>\n"
					},
					{
						"publication": "Bloomberg Businessweek",
						"text": "<p>&ldquo;[Here] are tart meditations on the creative impulse and the artistic ego, on the interplay between reality and fantasy and the often-pitiful limits of human communication. . . . Smoldering.&rdquo;</p>\n"
					},
					{
						"publication": "Milwaukee Journal Sentinel",
						"text": "<p>&ldquo;Spellbinding, psychologically acute. . . . How much of Nora&rsquo;s fantasy is true . . . is the real subject of Messud&rsquo;s novel. . . . Exquisitely rendered.&rdquo;</p>\n"
					},
					{
						"publication": "Salon",
						"text": "<p>&quot;Hypnotic. . . . In Nora, Messud has conjured a self-contradictory yet acutely familiar character<em>;</em>&nbsp;we&rsquo;ve all met someone like her, if we aren&rsquo;t like her ourselves. . . . Nora does not become monstrous or pathological or even absurd. This, in a way, is her tragedy.&rdquo;</p>\n"
					},
					{
						"publication": "The Christian Science Monitor",
						"text": "<p>&ldquo;Messud is a tremendously smart, accomplished writer. . . . What the novel does, in spades, is give a voiceless woman a chance to howl.&rdquo;</p>\n"
					},
					{
						"publication": "Dallas News ",
						"text": "<p>&ldquo;Bracing. . . . In this fierce, feminist novel, the reader serves as Nora&rsquo;s confessor, and it&rsquo;s a pleasurable job to listen to someone so eloquent, whose insights about how women are valued in society and art are sharp and righteous.&rdquo;</p>\n"
					}
				]
			},
			"_doc": "b7b83284c7c65d58e4b1",
			"attachments": {},
			"_system": {
				"deleted": false,
				"changeset": "298:6083ceef1e3575a92232",
				"created_on": {
					"timestamp": "15-May-2017 14:59:21",
					"year": 2017,
					"month": 4,
					"day_of_month": 15,
					"hour": 14,
					"minute": 59,
					"second": 21,
					"millisecond": 965,
					"ms": 1494860361965,
					"iso_8601": "2017-05-15T14:59:21Z"
				},
				"created_by": "mmcginnis",
				"created_by_principal_id": "7683d13972fe921163df",
				"created_by_principal_domain_id": "3d96ab762d6c9248425b",
				"modified_on": {
					"timestamp": "26-May-2017 17:44:57",
					"year": 2017,
					"month": 4,
					"day_of_month": 26,
					"hour": 17,
					"minute": 44,
					"second": 57,
					"millisecond": 470,
					"ms": 1495820697470,
					"iso_8601": "2017-05-26T17:44:57Z"
				},
				"modified_by": "sdike",
				"modified_by_principal_id": "e4180bb7661ac1511f07",
				"modified_by_principal_domain_id": "3d96ab762d6c9248425b",
				"previousChangeset": "235:da85e23779b208d37b6f"
			},
			"_statistics": {
				"a:child": 1,
				"a:child_INCOMING": 1,
				"a:has_role": 4,
				"a:has_role_INCOMING": 4,
				"a:linked": 1,
				"a:linked_INCOMING": 1
			},
			"insightNode": "99f505c98cb37175bbe5/7df865401a95482cf6ba/b7b83284c7c65d58e4b1"
		},
		{
			"title": "when-the-world-was-steady",
			"isbn": "9780393355093",
			"bookTitle": "When the World Was Steady",
			"subtitle": "A Novel ",
			"url": "when-the-world-was-steady",
			"coverImage": "http://cdn.wwnorton.com/dam_booktitles/390/img/cover/9780393355093_198.jpeg",
			"summary": "<p><strong>A PEN/Faulkner Award finalist about two sisters’ divergent paths, from the author of <em>The Burning Girl</em> and <em>The Emperor’s Children</em>.</strong></p>\n\n<p>In this highly acclaimed novel, life isn’t all Emmy and Virginia Simpson anticipated. When Emmy’s marriage to an Australian man ends, she flees her home in Sydney to “find herself” on the island of Bali—only to become embroiled with a crew of international misfits and smugglers. Her prim and pious sister, Virginia, meanwhile, has never wandered far outside of London. Struggling to find meaning, she follows her aging mother’s advice to vacation on the Isle of Skye. On these two islands halfway around the world, the middle-aged sisters confront the costs of self-knowledge and their destinies with unexpected consequences.</p>\n",
			"orderButtonText": "Buy Now",
			"retailersLinks": [
				{
					"link": "https://www.amazon.com/When-World-Was-Steady-Novel/dp/0393355098/ref=sr_1_1?s=books&ie=UTF8&qid=1494860580&sr=1-1&keywords=9780393355093",
					"retailer": "Amazon"
				},
				{
					"link": "http://www.barnesandnoble.com/w/when-the-world-was-steady-claire-messud/1000479865?ean=9780393355093",
					"retailer": "Barnes & Noble"
				},
				{
					"link": "http://www.booksamillion.com/p/World-Was-Steady/Claire-Messud/9780393355093?id=6946195072950",
					"retailer": "Books-A-Million"
				},
				{
					"link": "https://itunes.apple.com/us/book/when-the-world-was-steady-a-novel/id1226618019?mt=11",
					"retailer": "iBooks"
				},
				{
					"link": "http://www.indiebound.org/book/9780393355093",
					"retailer": "IndieBound"
				}
			],
			"reviews": {
				"showReviews": true,
				"sectionTitle": "Praise for Claire Messud",
				"reviews": [
					{
						"publication": "The New York Times Book Review",
						"text": "<p>“A novelist of unnerving talent.”</p>\n"
					},
					{
						"publication": "The New Yorker ",
						"text": "<p>“[Messud] has the daring and assurance to take on Iris Murdoch–like questions about goodness and truth.”</p>\n"
					},
					{
						"publication": "The Chicago Tribune",
						"text": "<p>“Beautiful. . . . [Messud] has the imagination, the craft and the understanding of human nature to write about anything she chooses.”</p>\n"
					}
				]
			},
			"_doc": "88fdeb35d5c370b8fef7",
			"attachments": {},
			"_system": {
				"deleted": false,
				"changeset": "373:35c03f64c0fc5ddc7cf8",
				"created_on": {
					"timestamp": "15-May-2017 15:09:52",
					"year": 2017,
					"month": 4,
					"day_of_month": 15,
					"hour": 15,
					"minute": 9,
					"second": 52,
					"millisecond": 928,
					"ms": 1494860992928,
					"iso_8601": "2017-05-15T15:09:52Z"
				},
				"created_by": "mmcginnis",
				"created_by_principal_id": "7683d13972fe921163df",
				"created_by_principal_domain_id": "3d96ab762d6c9248425b",
				"modified_on": {
					"timestamp": "28-Aug-2017 15:23:30",
					"year": 2017,
					"month": 7,
					"day_of_month": 28,
					"hour": 15,
					"minute": 23,
					"second": 30,
					"millisecond": 738,
					"ms": 1503933810738,
					"iso_8601": "2017-08-28T15:23:30Z"
				},
				"modified_by": "scolca",
				"modified_by_principal_id": "a32a0841493c0930c2fa",
				"modified_by_principal_domain_id": "3d96ab762d6c9248425b",
				"previousChangeset": "316:2276c276dcac5febd9b7"
			},
			"_statistics": {
				"a:child": 1,
				"a:child_INCOMING": 1,
				"a:has_role": 4,
				"a:has_role_INCOMING": 4,
				"a:linked": 2,
				"a:linked_INCOMING": 2
			},
			"insightNode": "99f505c98cb37175bbe5/7df865401a95482cf6ba/88fdeb35d5c370b8fef7"
		},
		{
			"title": "the-hunters",
			"isbn": "9780393541816",
			"bookTitle": "The Hunters",
			"url": "the-hunters",
			"coverImage": "https://cdn.wwnorton.com/marketing/trade/messud/messud_hunters_pbk_252.jpg",
			"summary": "<p><b>From the acclaimed author of&nbsp;<em>The Emperor’s Children</em>&nbsp;and<em>&nbsp;The Burning Girl</em>,&nbsp;<em>The Hunters</em>&nbsp;is “a work of near-miraculous perfection” (Miranda Seymour,&nbsp;<em>New York Times</em>).</b></p>\n\n<p>&nbsp;</p>\n\n<p>In two jewel-like novellas, Claire Messud explores isolation and the nature of love. “A Simple Tale” is the moving story of Maria Poniatowski, an aging Ukrainian woman who, after liberation from servitude to the Germans, struggles with a new life in Canada. What of the past is she able to preserve, without burdening her present? “The Hunters,” the second novella, tells the story of an American academic in London who grows obsessed with the neighbors downstairs. Loneliness breeds an active imagination, one that may be destructive.</p>\n",
			"startDate": "07/08/2021",
			"orderButtonText": "Buy Now",
			"retailersLinks": [
				{
					"link": "https://www.amazon.com/Hunters-Claire-Messud/dp/0393541819/ref=tmm_pap_swatch_0?_encoding=UTF8&qid=1625767904&sr=1-1",
					"retailer": "Amazon"
				},
				{
					"link": "https://www.barnesandnoble.com/w/the-hunters-claire-messud/1103665841;jsessionid=0E7A2AAF07682AD5EA45EC39041D521A.prodny_store01-atgap12?ean=9780393541816",
					"retailer": "Barnes & Noble"
				},
				{
					"link": "https://books.apple.com/us/book/the-hunters/id1535835570784?mt=11",
					"retailer": "iBooks"
				},
				{
					"link": "https://www.indiebound.org/book/9780393541816",
					"retailer": "IndieBound"
				}
			],
			"reviews": {
				"showReviews": true,
				"sectionTitle": "Praise for The Hunters",
				"reviews": [
					{
						"publication": "The New York Times",
						"text": "<p>\"A marvelously subtle and poignant work, richly visualized, intensely written, compassionate without a hint of sentimentality....exceptional, a work of near-miraculous perfection.\"<br />\n&nbsp;</p>\n",
						"reviewBy": "Miranda Seymour"
					},
					{
						"publication": "San Francisco Chronicle",
						"text": "<p>\"Extremely well crafted . . . A literary intelligence far surpassing most other writers of her generation.\"</p>\n",
						"reviewBy": "Alan Cheuse"
					},
					{
						"publication": "Chicago Tribune ",
						"text": "<p>\"Messud's particular talent lies in her subtle crafting of the limits of the exile's inner world.\"</p>\n"
					}
				]
			},
			"_doc": "c95119b63147df8792c8",
			"attachments": {},
			"_system": {
				"deleted": false,
				"changeset": "498:917d7c1a97c69ab4d6b1",
				"created_on": {
					"timestamp": "15-May-2017 15:17:09",
					"year": 2017,
					"month": 4,
					"day_of_month": 15,
					"hour": 15,
					"minute": 17,
					"second": 9,
					"millisecond": 483,
					"ms": 1494861429483,
					"iso_8601": "2017-05-15T15:17:09Z"
				},
				"created_by": "mmcginnis",
				"created_by_principal_id": "7683d13972fe921163df",
				"created_by_principal_domain_id": "3d96ab762d6c9248425b",
				"modified_on": {
					"timestamp": "08-Jul-2021 18:43:56",
					"year": 2021,
					"month": 6,
					"day_of_month": 8,
					"hour": 18,
					"minute": 43,
					"second": 56,
					"millisecond": 133,
					"ms": 1625769836133,
					"iso_8601": "2021-07-08T18:43:56Z"
				},
				"modified_by": "mmcginnis",
				"modified_by_principal_id": "7683d13972fe921163df",
				"modified_by_principal_domain_id": "3d96ab762d6c9248425b",
				"previousChangeset": "497:709571ca523baf77bf4b",
				"edited_on": {
					"timestamp": "08-Jul-2021 18:43:56",
					"year": 2021,
					"month": 6,
					"day_of_month": 8,
					"hour": 18,
					"minute": 43,
					"second": 56,
					"millisecond": 133,
					"ms": 1625769836133,
					"iso_8601": "2021-07-08T18:43:56Z"
				},
				"edited_by": "mmcginnis",
				"edited_by_principal_id": "7683d13972fe921163df",
				"edited_by_principal_domain_id": "3d96ab762d6c9248425b",
				"rev": 498
			},
			"_statistics": {
				"a:child": 1,
				"a:child_INCOMING": 1,
				"a:has_role": 4,
				"a:has_role_INCOMING": 4,
				"a:linked": 1,
				"a:linked_INCOMING": 1
			},
			"insightNode": "99f505c98cb37175bbe5/7df865401a95482cf6ba/c95119b63147df8792c8"
		},
		{
			"title": "the-last-life",
			"isbn": "9780156011655",
			"bookTitle": "The Last Life",
			"subtitle": "A Novel ",
			"url": "the-last-life",
			"coverImage": "http://dz0xuupaj9dvo.cloudfront.net/cover/Claire_Messud/TheLastLife.jpg",
			"summary": "<p>Narrated by a fifteen-year-old girl with a ruthless regard for truth, The Last Life is a beautifully told novel of lies and ghosts, love and honor. Set in colonial Algeria, and in the south of France and New England, it is the tale of the LaBasse family, whose quiet integrity is shattered by the shots from a grandfather&#39;s rifle. As their world suddenly begins to crumble, long-hidden shame emerges: a son abandoned by the family before he was even born, a mother whose identity is not what she has claimed, a father whose act of defiance brings Hotel Bellevue-the family business-to its knees. Messud skillfully and inexorably describes how the stories we tell ourselves, and the lies to which we cling, can turn on us in a moment. It is a work of stunning power from a writer to watch.</p>\n",
			"orderButtonText": "Buy Now",
			"retailersLinks": [
				{
					"link": "https://www.amazon.com/Last-Life-Novel-Claire-Messud/dp/0156011654/ref=tmm_pap_swatch_0?_encoding=UTF8&qid=&sr=",
					"retailer": "Amazon"
				},
				{
					"link": "http://www.barnesandnoble.com/w/last-life-claire-messud/1100303053?ean=9780156011655",
					"retailer": "Barnes & Noble"
				},
				{
					"link": "http://www.booksamillion.com/p/Last-Life/Claire-Messud/9780156011655?id=6946195072950",
					"retailer": "Books-A-Million"
				},
				{
					"link": "https://itunes.apple.com/us/book/the-last-life/id427560539?mt=11",
					"retailer": "iBooks"
				},
				{
					"link": "http://www.indiebound.org/book/9780156011655",
					"retailer": "IndieBound"
				}
			],
			"reviews": {
				"showReviews": true,
				"sectionTitle": "Praise for The Last Life",
				"reviews": [
					{
						"publication": "Vogue",
						"text": "<p>&quot;A phenomenally controlled tour de force . . . Every step feels stunningly sure.</p>\n"
					},
					{
						"publication": "San Francisco Chronicle",
						"text": "<p>&quot;Haunting and evocative . . . Messud&#39;s is a novel rich in detail and warmly conveyed. . . . In its beautiful last pages, connections become crystalline, showing how we are linked in ways far deeper than religion, nationality or even blood-lines can delineate.&quot;</p>\n"
					},
					{
						"publication": "The New York Review of Books",
						"text": "<p>&quot;Remarkable . . . Messud has written a very serious book-always original, intense, and gripping.&quot;</p>\n"
					}
				]
			},
			"_doc": "2f713f5b50989ca19120",
			"attachments": {},
			"_system": {
				"deleted": false,
				"changeset": "297:579ea80203c94eb3d704",
				"created_on": {
					"timestamp": "15-May-2017 15:24:04",
					"year": 2017,
					"month": 4,
					"day_of_month": 15,
					"hour": 15,
					"minute": 24,
					"second": 4,
					"millisecond": 513,
					"ms": 1494861844513,
					"iso_8601": "2017-05-15T15:24:04Z"
				},
				"created_by": "mmcginnis",
				"created_by_principal_id": "7683d13972fe921163df",
				"created_by_principal_domain_id": "3d96ab762d6c9248425b",
				"modified_on": {
					"timestamp": "26-May-2017 17:44:34",
					"year": 2017,
					"month": 4,
					"day_of_month": 26,
					"hour": 17,
					"minute": 44,
					"second": 34,
					"millisecond": 529,
					"ms": 1495820674529,
					"iso_8601": "2017-05-26T17:44:34Z"
				},
				"modified_by": "sdike",
				"modified_by_principal_id": "e4180bb7661ac1511f07",
				"modified_by_principal_domain_id": "3d96ab762d6c9248425b",
				"previousChangeset": "235:da85e23779b208d37b6f"
			},
			"_statistics": {
				"a:child": 1,
				"a:child_INCOMING": 1,
				"a:has_role": 4,
				"a:has_role_INCOMING": 4,
				"a:linked": 1,
				"a:linked_INCOMING": 1
			},
			"insightNode": "99f505c98cb37175bbe5/7df865401a95482cf6ba/2f713f5b50989ca19120"
		},
		{
			"title": "kant-s-little-prussian-head-and-other-reasons-why-i-write",
			"isbn": "9780393882483",
			"bookTitle": "Kant's Little Prussian Head and Other Reasons Why I Write",
			"subtitle": "An Autobiography in Essays",
			"url": "kant's-little-prussian-head-and-other-reasons-why-i-write",
			"coverImage": "https://cdn.wwnorton.com/marketing/trade/messud/9781324006756_252.jpg",
			"summary": "<p><strong>A glimpse into a beloved novelist’s inner world, shaped by family, art, and literature.</strong></p>\n\n<p>In her fiction, Claire Messud \"has specialized in creating unusual female characters with ferocious, imaginative inner lives\" (Ruth Franklin,&nbsp;<em>New York Times Magazine</em>).&nbsp;<em>Kant’s Little Prussian Head and Other Reasons Why I Write</em>&nbsp;opens a window on Messud’s own life: a peripatetic upbringing; a warm, complicated family; and, throughout it all, her devotion to art and literature.</p>\n\n<p>In twenty-six intimate, brilliant, and funny essays, Messud reflects on a childhood move from her Connecticut home to Australia; the complex relationship between her modern Canadian mother and a fiercely single French Catholic aunt; and a trip to Beirut, where her&nbsp;<em>pied-noir</em>&nbsp;father had once lived, while he was dying. She meditates on contemporary classics from Kazuo Ishiguro, Teju Cole, Rachel Cusk, and Valeria Luiselli; examines three facets of Albert Camus and&nbsp;<em>The Stranger</em>; and tours her favorite paintings at Boston’s Museum of Fine Arts. In the luminous title essay, she explores her drive to write, born of the magic of sharing language and the transformative powers of “a single successful sentence.”</p>\n\n<p>Together, these essays show the inner workings of a dazzling literary mind. Crafting a vivid portrait of a life in celebration of the power of literature, Messud proves once again \"an absolute master storyteller\" (Rebecca Carroll,&nbsp;<em>Los Angeles Times</em>).</p>\n\n<p>\"All writing is autobiographical, but almost never in the ways we presume. This is a profound book about the intrication of literature and life, about the modest, miraculous ways art helps us to live. Claire Messud, with her lapidary intelligence and dizzying sense of history, is among the most luminous writers at work today.\"<br />\n―&nbsp;<strong>Garth Greenwell, author of&nbsp;<em>Cleanness</em>&nbsp;and&nbsp;<em>What Belongs to You</em></strong><br />\n<br />\n\"Moving and evocative…These intimate, contemplative and probing essays reveal Messud’s rich inner life and generosity of spirit.\"<br />\n―&nbsp;<strong><em>Publishers Weekly (starred review)</em></strong><br />\n<br />\n\"Powerful and inspirational: Messud is as fine a critic as she is a novelist.\"<br />\n―&nbsp;<strong><em>Kirkus Reviews (starred review)</em></strong></p>\n",
			"startDate": "08/12/2020",
			"orderButtonText": "Buy Now",
			"retailersLinks": [
				{
					"link": "https://www.amazon.com/dp/0393882489/ref=cm_sw_su_dp",
					"retailer": "Amazon"
				},
				{
					"link": "https://www.barnesandnoble.com/w/kants-little-prussian-head-and-other-reasons-why-i-write-claire-messud/1136155836;jsessionid=1F135C9A8DF7980749B68ABF1103F2C3.prodny_store01-atgap03?ean=9780393882483",
					"retailer": "Barnes & Noble"
				},
				{
					"link": "https://www.booksamillion.com/p/9780393882483",
					"retailer": "Books-A-Million"
				},
				{
					"link": "https://www.booksamillion.com/p/9780393882483",
					"retailer": "IndieBound"
				},
				{
					"link": "https://books.apple.com/us/book/kants-little-prussian-head-and-other-reasons-why-i/id1500799661",
					"retailer": "iBooks"
				}
			],
			"reviews": {
				"showReviews": false
			},
			"_doc": "1386945440a9338305b8",
			"attachments": {},
			"_system": {
				"deleted": false,
				"changeset": "520:63cb749b3e917dbff9df",
				"created_on": {
					"timestamp": "11-Aug-2020 19:26:38",
					"year": 2020,
					"month": 7,
					"day_of_month": 11,
					"hour": 19,
					"minute": 26,
					"second": 38,
					"millisecond": 467,
					"ms": 1597173998467,
					"iso_8601": "2020-08-11T19:26:38Z"
				},
				"created_by": "mmcginnis",
				"created_by_principal_id": "7683d13972fe921163df",
				"created_by_principal_domain_id": "3d96ab762d6c9248425b",
				"modified_on": {
					"timestamp": "03-Mar-2022 18:51:25",
					"year": 2022,
					"month": 2,
					"day_of_month": 3,
					"hour": 18,
					"minute": 51,
					"second": 25,
					"millisecond": 102,
					"ms": 1646333485102,
					"iso_8601": "2022-03-03T18:51:25Z"
				},
				"modified_by": "mmcginnis",
				"modified_by_principal_id": "7683d13972fe921163df",
				"modified_by_principal_domain_id": "3d96ab762d6c9248425b",
				"edited_on": {
					"timestamp": "03-Mar-2022 18:51:25",
					"year": 2022,
					"month": 2,
					"day_of_month": 3,
					"hour": 18,
					"minute": 51,
					"second": 25,
					"millisecond": 102,
					"ms": 1646333485102,
					"iso_8601": "2022-03-03T18:51:25Z"
				},
				"edited_by": "mmcginnis",
				"edited_by_principal_id": "7683d13972fe921163df",
				"edited_by_principal_domain_id": "3d96ab762d6c9248425b",
				"previousChangeset": "517:f4cd2b27dcafdccd9115",
				"rev": 520
			},
			"_statistics": {},
			"insightNode": "99f505c98cb37175bbe5/7df865401a95482cf6ba/1386945440a9338305b8"
		},
		{
			"_formKey": "booksmasterform",
			"title": "this-strange-eventful-history",
			"isbn": "978-0-393-63504-1",
			"bookTitle": "This Strange Eventful History",
			"subtitle": "A Novel",
			"url": "this-strange-eventful-history",
			"coverImage": "https://cdn.wwnorton.com/marketing/trade/messud/messud_strange-eventful-history_252.jpg",
			"summary": "<p><b>One of <em>Oprah Daily</em>'s Most Anticipated Books of 2024 • One of <em>New York</em> magazine's \"23 Books We Can’t Wait to Read in 2024\" • One of <em>The Guardian</em>'s \"Books to Look Out for in 2024\" • One of <em>The Globe &amp; Mail</em>'s Most Anticipated Books of 2024 • One of <em>BookPage</em>'s Most Anticipated fiction of 2024 • One of <em>Literary Hub</em>'s “Most Anticipated Books of 2024” • One of&nbsp;<em>Book Riot</em>'s \"Most Anticipated Books of 2024\"<br />\n<br />\nAn immersive, masterful story of a family born on the wrong side of history, from one of our finest contemporary novelists.</b><br />\n&nbsp;</p>\n\n<p>Over seven decades, from 1940 to 2010, the <em>pieds-noirs</em> Cassars live in an itinerant state—separated in the chaos of World War II, running from a complicated colonial homeland, and, after Algerian independence, without a homeland at all.&nbsp;<em>This Strange Eventful History</em>, told with historical sweep, is above all a family story: of patriarch Gaston and his wife Lucienne, whose myth of perfect love sustains them and stifles their children; of François and Denise, devoted siblings connected by their family’s strangeness; of François’s union with Barbara, a woman so culturally different they can barely comprehend one another; of Chloe, the result of that union, who believes that telling these buried stories will bring them all peace.</p>\n\n<p>Inspired in part by long-ago stories from her own family’s history, Claire Messud animates her characters’ rich interior lives amid the social and political upheaval of the recent past. As profoundly intimate as it is expansive, <em>This Strange Eventful History</em> is “a tour de force…one of those rare novels that a reader doesn’t merely read but lives through with the characters” (Yiyun Li).</p>\n",
			"startDate": "01/25/2024",
			"orderButtonText": "Buy Now",
			"retailersLinks": [
				{
					"link": "https://www.amazon.com/dp/1324110406/",
					"retailer": "Amazon"
				},
				{
					"link": "https://www.barnesandnoble.com/w/this-strange-eventful-history-claire-messud/1143237241?ean=9781324110408",
					"retailer": "Barnes & Noble"
				},
				{
					"link": "https://www.booksamillion.com/p/9781324110408",
					"retailer": "Books-A-Million"
				},
				{
					"link": "https://bookshop.org/p/books/this-strange-eventful-history-claire-messud/20610017?ean=9781324110408&next=t",
					"retailer": "IndieBound"
				},
				{
					"link": "https://books.apple.com/us/book/this-strange-eventful-history-a-novel/id6467144249",
					"retailer": "iBooks"
				}
			],
			"reviews": {
				"showReviews": false
			},
			"_doc": "74bc817f5acf74c65d14",
			"attachments": {},
			"_system": {
				"deleted": false,
				"changeset": "563:eaa52a7fa6eae195a91e",
				"created_on": {
					"timestamp": "25-Jan-2024 17:10:03",
					"year": 2024,
					"month": 0,
					"day_of_month": 25,
					"hour": 17,
					"minute": 10,
					"second": 3,
					"millisecond": 389,
					"ms": 1706202603389,
					"iso_8601": "2024-01-25T17:10:03Z"
				},
				"created_by": "mmcginnis",
				"created_by_principal_id": "7683d13972fe921163df",
				"created_by_principal_domain_id": "3d96ab762d6c9248425b",
				"modified_on": {
					"timestamp": "09-Apr-2025 20:39:37",
					"year": 2025,
					"month": 3,
					"day_of_month": 9,
					"hour": 20,
					"minute": 39,
					"second": 37,
					"millisecond": 636,
					"ms": 1744231177636,
					"iso_8601": "2025-04-09T20:39:37Z"
				},
				"modified_by": "mmcginnis",
				"modified_by_principal_id": "7683d13972fe921163df",
				"modified_by_principal_domain_id": "3d96ab762d6c9248425b",
				"edited_on": {
					"timestamp": "09-Apr-2025 20:39:37",
					"year": 2025,
					"month": 3,
					"day_of_month": 9,
					"hour": 20,
					"minute": 39,
					"second": 37,
					"millisecond": 636,
					"ms": 1744231177636,
					"iso_8601": "2025-04-09T20:39:37Z"
				},
				"edited_by": "mmcginnis",
				"edited_by_principal_id": "7683d13972fe921163df",
				"edited_by_principal_domain_id": "3d96ab762d6c9248425b",
				"previousChangeset": "559:b1fd843ab56b5eef59ca",
				"rev": 563
			},
			"_statistics": {},
			"insightNode": "99f505c98cb37175bbe5/7df865401a95482cf6ba/74bc817f5acf74c65d14"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/jsondata/books.json
// module id = 505
// module chunks = 0